import { render, staticRenderFns } from "./OnboardingEnd.vue?vue&type=template&id=4dd619e4&scoped=true&"
import script from "./OnboardingEnd.vue?vue&type=script&lang=js&"
export * from "./OnboardingEnd.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingEnd.vue?vue&type=style&index=0&id=4dd619e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd619e4",
  null
  
)

export default component.exports